'use client';

import {
  datadogLogs,
  Site,
} from '@datadog/browser-logs';
import {
  appVersion,
  datadogClientToken,
  environment,
  isDatadogEnabled,
} from 'env';
import {
  browserId,
  tabId,
} from 'utils/correlationIds';

let ddInitialized = false;

export const enabledLogs = isDatadogEnabled && ['qa', 'prod'].includes((environment ?? '').toLowerCase());
// Initialize Datadog Browser Logs once per client session
export function initDatadogLogs() {
  try {
    if (!ddInitialized && enabledLogs) {
      datadogLogs.init({
        clientToken: datadogClientToken,
        site: ('us3.datadoghq.com') as Site,
        service: 'populate-emr-app',
        forwardConsoleLogs: ['error', 'warn', 'info'],
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        env: environment,
        version: appVersion,
      });
      ddInitialized = true;
    }
    datadogLogs.setGlobalContext({
      browser_id: browserId,
      tab_id: tabId,
    });
    // for debugging Application Version
    console.log('~~~Application Version:', appVersion, '~~~');
  } catch {
    // No-op: do not block app if Datadog init fails
  }
}

// Eager init on import in client
initDatadogLogs();
